module.exports = __webpack_public_path__ + "static/img/RASR2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASR2_1.png
// module id = 5YSO
// module chunks = 0